import { Bar, BarChart, CartesianGrid, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { Card } from '@radix-ui/themes'

import { getTotalMargin } from '../../utils/margin-report-helpers'

import { formatWithThousandSep } from '@/utils/utils'
import Margin from '@/interfaces/Margin'

export const MarginBarChartCard = ({ margins }: { margins: Margin[] }) => {
  const group = margins.reduce<Record<string, { sum: number; count: number }>>((acc, row) => {
    const { brand, model, year, plate } = row
    const key = `${plate} - ${brand} ${model} ${year}`

    acc[key] ??= { sum: 0, count: 0 }
    // Total margin (vehicle margin + credit commission), matching the "Margen Total" column
    acc[key].sum += getTotalMargin(row)
    acc[key].count += 1

    return acc
  }, {})

  const data = Object.entries(group).map(([name, { sum, count }]) => ({
    value: sum / count,
    name,
  }))

  const formatter = (value: number | string) => '$' + formatWithThousandSep(Number(value))

  return (
    <Card>
      <ResponsiveContainer aspect={3}>
        <BarChart data={data} margin={{ top: 30, left: 30 }}>
          <CartesianGrid strokeDasharray="5 5" stroke="var(--gray-6)" />
          <XAxis
            dataKey="name"
            stroke="var(--gray-9)"
            fontSize="var(--font-size-1)"
            interval={0}
            angle={-30}
            textAnchor="end"
            height={80}
          />
          <YAxis stroke="var(--gray-9)" tickFormatter={formatter} fontSize="var(--font-size-1)" />
          <Tooltip
            contentStyle={{ borderRadius: 'var(--radius-4)', boxShadow: 'var(--shadow-5)', borderWidth: 0 }}
            labelStyle={{ color: 'var(--gray-11)' }}
            itemStyle={{ color: 'var(--cyan-9)' }}
            cursor={{ fill: 'var(--gray-a3)' }}
            formatter={formatter}
          />
          <ReferenceLine stroke="var(--gray-9)" y={0} />
          <Bar dataKey="value" fill="var(--cyan-7)" name="Margen Total" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  )
}
